export const ROOT_SELECTOR = "[data-curriculum-widget='habitat']";

const getApiUrl = (): string => {
  switch (process.env.NODE_ENV) {
    case 'production':
      return 'https://my.curriculum.com/api/v1';
    case 'staging':
      return 'https://gateway.curriculum.com/api/v1';
    case 'development':
      return 'https://api.curriculum.com/api/v1';
    default:
      throw new Error(`Invalid NODE_ENV: ${process.env.NODE_ENV}. Must be 'production', 'staging', or 'development'.`);
  }
};
export const API_URL = getApiUrl();

export const uuidRE =
  /[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}.(png|jp?eg)/gm;
